import { z } from 'zod';

export const tipoCupomEnum = z.enum(['FIXO', 'PORCENTAGEM']);
export const statusCupomEnum = z.enum(['ATIVO', 'INATIVO']);

export const cupomSchema = z.object({
  codigo: z.string().min(1, 'Código obrigatório'),
  tipo: tipoCupomEnum,
  valor: z
    .number({ invalid_type_error: 'Valor obrigatório' })
    .nonnegative('Valor deve ser positivo'),
  quantidadeDisponivel: z
    .number({ invalid_type_error: 'Quantidade obrigatória' })
    .int('Quantidade deve ser inteira')
    .nonnegative('Quantidade deve ser positiva'),
  status: statusCupomEnum,
  dataExpiracao: z.string().optional().or(z.literal('')),
});

export type CupomFormValues = z.infer<typeof cupomSchema>;
